import { z } from 'zod';
import {
  dateRangeFields,
  isOrderedRange,
  ORDERED_RANGE_ISSUE,
  paginationSchema,
  uuidSchema,
} from '../primitives.js';
import { AUDIT_ACTIONS, AUDIT_ENTITIES } from '../enums.js';

export const auditFiltersSchema = paginationSchema.merge(dateRangeFields).extend({
  entityType: z.enum(AUDIT_ENTITIES).optional(),
  entityId: uuidSchema.optional(),
  action: z.enum(AUDIT_ACTIONS).optional(),
  actorUserId: uuidSchema.optional(),
}).refine((v: { from?: string | undefined; to?: string | undefined }) => isOrderedRange(v), { message: ORDERED_RANGE_ISSUE.message, path: ['from'] });
export type AuditFilters = z.infer<typeof auditFiltersSchema>;

export const auditLogSchema = z.object({
  id: uuidSchema,
  businessId: uuidSchema.nullable(),
  actorUserId: uuidSchema.nullable(),
  actorName: z.string().nullable(),
  actorEmail: z.string().nullable(),
  actorIp: z.string().nullable(),
  action: z.enum(AUDIT_ACTIONS),
  entityType: z.enum(AUDIT_ENTITIES),
  entityId: uuidSchema.nullable(),
  /** Human summary, e.g. "Sale SAL-0042 amount 5000.00 → 4500.00". */
  summary: z.string().nullable(),
  before: z.record(z.unknown()).nullable(),
  after: z.record(z.unknown()).nullable(),
  changedFields: z.array(z.string()),
  requestId: z.string().nullable(),
  createdAt: z.string(),
});
export type AuditLog = z.infer<typeof auditLogSchema>;
